import * as React from 'react';
/**
 *
 * Original name: sound on
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2991%3A271
 *
 */
export const SoundOnFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M7.5 8.5C5.178 8.5 4 9.678 4 12s1.178 3.5 3.5 3.5h1.523l5.477 3.65V4.85L9.023 8.5H7.5Zm11.834-2.524-1.05 1.05C19.43 8.1 20 9.75 20 12s-.57 3.9-1.715 4.975l1.05 1.05C20.753 16.67 21.5 14.64 21.5 12c0-2.64-.747-4.67-2.166-6.024Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "m17.124 8.186-1.07 1.07c.64.569.946 1.467.946 2.744 0 1.277-.306 2.175-.946 2.743l1.07 1.07c.905-.84 1.376-2.116 1.376-3.813s-.47-2.974-1.376-3.814Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
